//・利用規約チェックボックスが最初からエラー表示になっているのを防ぐ
//https://note.com/show_kanamaru/n/n33ee68d4b4c4

// Checkbox.tsx

import React, { useState } from 'react';

import { CheckboxField, ScrollView } from "@aws-amplify/ui-react";
import { TERMS_OF_USE_PATH } from "../../constants/Constant";
import { getServerTime } from "../../utils/Util";

type Props = {
  validationErrors: {
    [key: string]: string;
  };
};

export const RiyoukiyakuCheckbox: React.FC<Props> = ({ validationErrors }) => {
  const [touched, setTouched] = useState<boolean>(false);
  const [lastConsentDateTime, setLastConsentDateTime] = useState("");
  const [isReceiveEmail, setIsReceiveEmail] = useState<boolean>(true);
  const [marketMailDateTime, setMarketMailDateTime] = useState("");

  const handleClickAckowledgement = async (e: {
    target: { checked: any; value: any };
  }) => {
    setTouched(true);
    if (e.target.checked) {
      const serverTime = await getServerTime();
      setLastConsentDateTime(serverTime ? serverTime.toISOString() : "");
      setMarketMailDateTime(serverTime ? serverTime.toISOString() : "");
    } else {
      setLastConsentDateTime("");
      setMarketMailDateTime("");
    }
  };

  return (
    <>
      <CheckboxField
        errorMessage={validationErrors.acknowledgement}
        hasError={touched && !!validationErrors.acknowledgement}
        name="acknowledgement"
        value="yes"
        onChange={handleClickAckowledgement}
        label={
          <div>
            <a
              href={TERMS_OF_USE_PATH}
              target="_blank"
              rel="noopener noreferrer"
            >
              利用規約
            </a>{" "}
            に同意する
          </div>
        }
      />
      <input
        type="hidden"
        readOnly
        name="custom:lastconsentdatetime"
        value={lastConsentDateTime}
      />
      <ScrollView width="100%">
        <iframe
          src={TERMS_OF_USE_PATH}
          className="w-100 border border-1"
          height="200"
          title="AccountTourokuRiyouKiyaku"
        ></iframe>
      </ScrollView>
      <CheckboxField
        name="custom:marketingmailreceive"
        checked={isReceiveEmail}
        value={isReceiveEmail.toString()}
        onChange={(e) => setIsReceiveEmail(e.target.checked)}
        label="MAPPLE法務局地図ビューアからの各種案内のメールを受け取る"
      />
      <input
        type="hidden"
        readOnly
        name="custom:marketmaildatetime"
        value={marketMailDateTime}
      />
    </>
  );
};